import { useState } from "react";
import { FilterSection, FilterValues } from "../../data-model/filterValues";
import { useFilterValues } from "../../contexts/filterValuesContext";
import FilterLines from "../../svg/filter-lines";
import Filter from "../filter/filter";
import SideModal from "../modals/filterModal/filterModal";

interface FilterButtonProps {
  name: string;
  filterSectionsData: FilterSection[];
  onFilterApply: (data: FilterValues) => void;
  screenName?: string;
}

/**
 * Opens the filter side modal and shows the applied filter count badge.
 * Persists applied filters in FilterValuesContext (no Redux / apiWorker).
 *
 * @param props - Filter name, sections, and apply callback
 * @returns Filter toolbar button + modal
 */
const FilterButton = (props: FilterButtonProps) => {
  const [openModal, setOpenModal] = useState(false);
  const { getFilterByName, setFilter } = useFilterValues();

  const getFilterCount = () => {
    return getFilterByName(props.name)?.filterCount ?? 0;
  };

  return (
    <div
      className="filter-button-container flex h-10 w-fit items-center justify-center gap-1 rounded border border-primaryGray-14 px-3 py-2 hover:cursor-pointer hover:shadow-sm"
      onClick={() => {
        setOpenModal(true);
      }}
    >
      <div className="filter-button--text text-small font-semibold text-primaryGray-3">
        Filters
      </div>
      <div className="filter-button--number flex h-5 w-5 items-center justify-center rounded-[50%] bg-grayscaleBlack-2 p-1 text-center text-tiny font-semibold text-white">
        {getFilterCount()}
      </div>
      <div className="filter-button--icon">
        <FilterLines />
      </div>
      {openModal && (
        <SideModal
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          children={
            <Filter
              onClose={() => setOpenModal(false)}
              name={props.name}
              onApplyFilter={(data) => {
                setFilter(data);
                props.onFilterApply(data);
              }}
              filterSectionsData={props.filterSectionsData}
              screenName={props.screenName}
            />
          }
        />
      )}
    </div>
  );
};

export default FilterButton;
